var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$slots['default'])?_c('div',{staticClass:"loader-title"},[_vm._t("default")],2):_vm._e(),_c('div',{staticClass:"loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }